import type { Lang } from "@/config/routes";

export function formatDateTime(
	iso: string | null | undefined,
	lang: Lang,
): string {
	if (!iso) return "";
	return new Intl.DateTimeFormat(lang, {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit",
		hour12: false,
	}).format(new Date(iso));
}

export function formatDate(iso: string | null | undefined, lang: Lang): string {
	if (!iso) return "";
	return new Intl.DateTimeFormat(lang, {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
	}).format(new Date(iso));
}
